/* eslint-disable @typescript-eslint/no-explicit-any */
import { type NamespaceKeys, type NestedKeyOf } from 'next-intl'
import { Translator } from '../types'

function getTranslatorWithFallback<T extends Translator<NamespaceKeys<IntlMessages, NestedKeyOf<IntlMessages>>>>(
  t: T
): T {
  return ((key: any, options: any) => {
    const message = (t as (key: any, options: any) => string)(key, options) ?? key
    if (message === key) {
      return (options as unknown as { defaultValue?: string })?.defaultValue ?? ''
    }
    return message
  }) as unknown as T
}

export default getTranslatorWithFallback
